import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { ImageXDefinition, ImageXProps } from '@wix/thunderbolt-components';

export const props = withCompInfo<ImageXProps, ImageXDefinition, ImageXProps>()(
  [],
  (_, carmiProps) => carmiProps,
);

export default createComponentMapperModel({
  props,
});
